module.exports = __webpack_public_path__ + "static/media/_scan_fail_whoops.a4b754e4.png";